<app-header></app-header>
<div class="container">
  <app-info-panel class="info-panel"></app-info-panel>
  <app-map class="map-full"></app-map>
</div>
